<template>
<v-select
  :value="value"
  @input="ev => $emit('input', ev)"
  :items="items"
  :label="label"
  outline
  hide-details
  clearable>
  <template slot="item" slot-scope="data">
    <v-icon color="primary" :key="i" v-for="i in data.item.lvl">
      mdi-forward
    </v-icon>
    {{ data.item.text }}
  </template>
</v-select>
</template>

<script>
export default {
  name: 'filtro-gruppo',
  props: {
    label: String,
    value: String,
    items: Array,
  },
};
</script>

<style lang="stylus" scoped>
</style>
